import { Injectable, inject } from '@angular/core';
import { Confirmation, ConfirmationService } from 'primeng/api';

type ConfirmDialogInput = string | Partial<Confirmation>;

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService {
  private readonly confirmationService = inject(ConfirmationService);

  private readonly defaults: Partial<Confirmation> = {
    header: 'Atención',
    closable: false,
    closeOnEscape: false,
    icon: 'pi pi-question-circle',
    acceptButtonProps: {
      label: 'Si',
      severity: 'primary',
      outlined: false,
    },
    rejectButtonProps: {
      label: 'No',
      severity: 'danger',
      outlined: false,
    },
    rejectVisible: true
  };

  confirm(input: ConfirmDialogInput): Promise<boolean> {
    const config = typeof input === 'string' ? { message: input } : input;

    const mergedConfig: Confirmation = {
      ...this.defaults,
      ...config,
      acceptButtonProps: {
        ...(this.defaults.acceptButtonProps as Record<string, unknown>),
        ...(config.acceptButtonProps as Record<string, unknown>),
      },
      rejectButtonProps: {
        ...(this.defaults.rejectButtonProps as Record<string, unknown>),
        ...(config.rejectButtonProps as Record<string, unknown>),
      },
    } as Confirmation;

    return new Promise<boolean>((resolve) => {
      this.confirmationService.confirm({
        ...mergedConfig,
        accept: () => {
          config.accept?.();
          resolve(true);
        },
        reject: (type: unknown) => {
          config.reject?.(type as never);
          resolve(false);
        },
      });
    });
  }

  //Ejemplos de uso:
  // 1) Minimo: solo mensaje
  // const ok = await this.confirmDialogService.confirm('Desea continuar?');

  // // 2) Personalizado parcial: solo lo que quieras cambiar
  // const ok2 = await this.confirmDialogService.confirm({
  //   message: 'Desea continuar?',
  //   acceptButtonProps: { label: 'Continuar' },
  //   rejectButtonProps: { label: 'Cancelar' },
  // });

  // // 3) Personalizado completo: puedes enviar todas las props de PrimeNG
  // const ok3 = await this.confirmDialogService.confirm({
  //   message: 'Confirmacion avanzada',
  //   header: 'Atencion',
  //   icon: 'pi pi-exclamation-triangle',
  //   closable: true,
  //   closeOnEscape: true,
  //   acceptButtonProps: { label: 'Si', severity: 'success' },
  //   rejectButtonProps: { label: 'No', severity: 'secondary', outlined: true },
  // });
}
